/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Model } from '@app/shared/models/model.model';
import { Company } from '@app/settings/companies/company.model';
import { EventGroup } from '@app/events/events-groups/event-group.model';
import { Hotel } from '@app/hotels/hotels/hotel.model';
import { Room } from '@app/hotels/rooms/room.model';
import { Events } from '@app/events/events/events.model';
import { Client } from '@app/clients/clients/client.model';
import { Sale } from '@app/sales/sales/sale.model';

export class RequestModel extends Model {
  id: number;
  company_id: number;
  company?: Company;
  company_website_id: number;
  company_website?: any;
  event_id: number;
  event?: Events;
  event_group_id: number;
  event_group?: EventGroup;
  hotel_id: number;
  hotel?: Hotel;
  company_name: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  requirements: string;
  notes: string;
  budget: number;
  rooms: Array<Room>;
  type: string;
  hotel_stars: number;
  client_id: number;
  client?: Client;
  raw_data?: any;
  sale?: Sale;

  deserialize(input: any): this {
    super.deserialize(input);

    if (input.company) {
      this.company = new Company().deserialize(input.company);
    }

    if (input.event) {
      this.event = new Events().deserialize(input.event);
    }

    return this;
  }
}
